import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { fetchArticlesCash, fetchArticlesExpenditures, fetchFilials, } from '../../action/handbook';
import Loader from '../utils/Loader';
import Portlet from '../utils/Portlet';
import ErrorContainer from '../utils/ErrorContainer';
import { setUIvisible } from '../../action/UImobile';
import { fetchOtherExpenditures , fetchWorkingShift, setCassaFilters, setOtherExpenditures, setWorkingShifts } from '../../action/cassa';
import Select from 'react-select';
import moment from 'moment';
import '../../styles/cassa.css'
import DateInput from '../utils/DateInput';
import { optionsMovementCash } from '../../constants/app';
import ReportOtherExpenditureTable from './ReportOtherExpenditureTable';
import ReportWorkingShiftsTable from './ReportWorkingShiftsTable';
import { utils, writeFileXLSX } from 'xlsx';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class ReportList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            articlesFilters: {
                article: null,
                typeMovementCash: null,
                typeTransaction: null,                
            },
            typeReport: {label: 'Кассовые статьи', value: 'articlesCash'}
        };
    }

    componentDidMount() {
        const getData = async () => {
            let date = new Date();
            date.setDate(1);
            date.setHours(0, 0, 0, 0);

            await Promise.all([
                this.props.fetchFilials(null),
                this.props.fetchArticlesExpenditures(true),
                this.props.fetchArticlesCash(true),
                this.onChangeDateInput('createdStartDate')(date)
            ]);
        }

        getData();
    }

    componentWillUnmount(){
        const { filters } = this.props;
        let updated = {
            ...filters
        }

        updated.createdEndDate = null;
        updated.createdStartDate = null;

        this.props.setCassaFilters(updated);
        this.props.setWorkingShifts(null);
        this.props.setOtherExpenditures(null);
    }

    changeTypeReport = (data) => {
        const filters = {...this.state.articlesFilters};
        filters.id = null;

        if(data.value === 'otherExpenditure') filters.typeMovementCash = null;

        this.setState({ articlesFilters: filters });
        this.setState({ typeReport: data });
    }

    setArticleFilters = (field) => (e) =>  {
        const data = {...this.state.articlesFilters};

        if (e.value) {
            data[field] = e;
        } else {
            data[field] = null;
        }

        this.setState({ articlesFilters: data });
    }

    setFilters = (field) => (data) => {
        const { filters } = this.props;
        let updated = {
            ...filters,
            [field]: data
        }

        if(data.value === null) {
            updated = {
                ...filters,
                [field]: null
            }
        }

        this.props.setCassaFilters(updated);
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props;

        if(field === 'createdStartDate') {
            date.setHours(0, 0, 0, 0);
        } else {
            date.setHours(23, 59, 59, 999);
        }

        const updated = {
            ...filters,
            [field]: date,
        };

        if (field === 'createdStartDate') {            
            updated.createdEndDate = moment(date).endOf('month').toDate();
        }

        if(updated.createdStartDate && moment(updated.createdEndDate) < moment(updated.createdStartDate)) {
            updated.createdStartDate = moment(updated.createdEndDate).startOf('month').toDate();
        }
        
        this.props.setCassaFilters(updated);
    }

    onSearchDate = () => {
        if(this.state.typeReport.value === 'articlesCash') {
            this.props.fetchWorkingShift();
        } else {
            this.props.fetchOtherExpenditures();
        }
    }

    renderAdress(item) {
        return `${item.city.name}, ${item.street}, ${item.house}`;
    }

    onRefresh = () => {
        if(this.state.typeReport.value === 'articlesCash') {
            this.props.fetchWorkingShift();
        } else {
        this.props.fetchOtherExpenditures();
        }
    }

    onExport = () => {
        if(this.state.typeReport.value === 'articlesCash') {
            const data = this.props.articlesCash.filter((el) => {
                if (this.state.articlesFilters && this.state.articlesFilters.article && this.state.articlesFilters.article.value) return el.id === this.state.articlesFilters.article.value;
                return true;
                }).reduce((prev = [], item) => {
                const result = {
                    id: item.id,
                    name: item.name,
                    sum: (this.props.workingShiftsList.reduce((acc, el) => {
                        return acc + parseFloat(!el.articlesCashes ? 0 : el.articlesCashes.reduce((sum, article) => {
                            let check = true;
                            check = check && (article.articleId ? article.articleId === item.id : article.name === item.name);
                            if (this.state.articlesFilters && this.state.articlesFilters.typeTransaction) check = check && (article.typeTransaction === this.state.articlesFilters.typeTransaction.value);
                            if (this.state.articlesFilters && this.state.articlesFilters.typeMovementCash) check = check && (article.typeMovementCash === this.state.articlesFilters.typeMovementCash.value);
                            if(check) return sum + parseFloat(article.sum);
                            return sum;
                        }, 0))
                    }, 0)).toFixed(2)
                }
                prev.push(result);

                return prev;
            }, []);

            const filterData = data.map(item => {
                return {
                    'id': item.id,
                    'Операция': item.name,
                    'Сумма': item.sum
                }
            });

            const ws = utils.json_to_sheet(filterData);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "Data");
            writeFileXLSX(wb, `Кассовые статьи ${this.checkPointValue().label} ${moment(this.props.filters.createdStartDate).format('DD.MM.YYYY')}-${moment(this.props.filters.createdEndDate).format('DD.MM.YYYY')}${this.state.articlesFilters.typeTransaction ? ' ' + this.state.articlesFilters.typeTransaction.label : ''}${this.state.articlesFilters.typeMovementCash ? ' ' + this.state.articlesFilters.typeMovementCash.label : ''}${(this.state.articlesFilters.article && this.state.articlesFilters.article.value) ? ' Операция - ' + this.state.articlesFilters.article.label : ''}.xlsx`);
        } else {
            const data = this.props.articlesExpenditures.filter((el) => {
            let check = true;

            if (this.state.articlesFilters && this.state.articlesFilters.article && this.state.articlesFilters.article.value) check = check && (el.articleId ? el.articleId === this.state.articlesFilters.article.value : el.name === this.state.articlesFilters.article.label);
            if (this.state.articlesFilters && this.state.articlesFilters.typeTransaction) check = check && (el.typeTransaction === this.state.articlesFilters.typeTransaction.value || el.typeTransaction === 'all');
            return check;
            }).reduce((prev = [], item) => {
                const result = {
                    id: item.id,
                    name: item.name,
                    sum: (this.props.otherExpenditures.reduce((acc, el) => {
                        let check = true;

                        check = check && (el.articleId ? el.articleId === item.id : el.name === item.name);

                        if (this.state.articlesFilters && this.state.articlesFilters.typeTransaction) check = check && (el.typeTransaction === this.state.articlesFilters.typeTransaction.value);
                        if(check) return acc + parseFloat(el.sum);
                        return acc;
                    }, 0)).toFixed(2)
                }
                prev.push(result);

                return prev;
            }, []);

            const filterData = data.map(item => {
                return {
                    'id': item.id,
                    'Операция': item.name,
                    'Сумма': item.sum
                }
            });

            const ws = utils.json_to_sheet(filterData);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "Data");
            writeFileXLSX(wb, `Расходы вне смены ${this.checkPointValue().label} ${moment(this.props.filters.createdStartDate).format('DD.MM.YYYY')}-${moment(this.props.filters.createdEndDate).format('DD.MM.YYYY')}${this.state.articlesFilters.typeTransaction ? ' ' + this.state.articlesFilters.typeTransaction.label : ''}${(this.state.articlesFilters.article && this.state.articlesFilters.article.value) ? ' Операция - ' + this.state.articlesFilters.article.label : ''}.xlsx`);
        }
    }

    checkPointValue() {
        if (this.props.filters.point) {
            return this.props.filters.point;
        }

        if(!this.props.filters.point && (this.props.filials.length === 0 || !this.props.filials[0])) {
            return null;
        }

        if(this.props.filials[0]) {
            return {value: this.props.filials[0].id, label: this.renderAdress(this.props.filials[0])};
        }

        return null;
    }

    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Отчеты</h3>
                    <button className="btn btn-secondary btn-icon">
                        <i onClick={this.onRefresh} className='la la-refresh'/>
                    </button>
                    <div className="kt-subheader__group" id="kt_subheader_search">                       
                    </div>
                </div>
                <div className="kt-subheader__toolbar">                            
                        <button onClick={() => this.onExport()} className='btn btn-dark btn-icon-sm'>
                            Экспорт
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    optionsArticles() {
        if(this.state.typeReport.value === 'articlesCash') {
            return [
                {value: null, label: 'Все статьи'},
                ...this.props.articlesCash.sort((a, b) => {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    })
                    .filter((el) => {
                        let check = true;

                        if (this.state.articlesFilters.typeMovementCash) check = check && (el.typeMovementCash === this.state.articlesFilters.typeMovementCash.value);
                        if (this.state.articlesFilters.typeTransaction) check = check && (el.typeTransaction === this.state.articlesFilters.typeTransaction.value);
                        return check;
                    })
                    .map(el => ({ value: el.id, label: el.name }))
            ]
        } else {
            return [
                {value: null, label: 'Все статьи'},
                ...this.props.articlesExpenditures
                    .sort((a, b) => {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    })
                    .filter((el) => {
                        let check = true;

                        if (this.state.articlesFilters.typeTransaction) check = check && (el.typeTransaction === this.state.articlesFilters.typeTransaction.value || el.typeTransaction === 'all');
                        return check;
                    })
                    .map(el => ({ value: el.id, label: el.name }))
            ]
        }
    }

    renderFiltersBlock(){
            return(
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginTop: '10px', gap: '10px'}}>            
                    <div style={{ width: 250 }}>
                        <Select
                        isLoading={this.props.loadingFilials}
                        isDisabled={this.props.loadingFilials}
                        value={this.checkPointValue()}
                        closeMenuOnSelect={true}
                        onChange={this.setFilters('point')}
                        options={this.props.filials.map((el) => ({ value: el.id, label: this.renderAdress(el) }))}
                        placeholder="Филиал"
                        noOptionsMessage={() => 'Нет филиалов'}
                        />
                    </div>
                    {<div style={{ width: 175 }}>
                        <Select
                        isLoading={this.props.loadingArticles || this.props.loadingFilials}
                        isDisabled={this.props.loadingArticles || this.props.loadingFilials}
                        value={this.state.typeReport}
                        closeMenuOnSelect={true}
                        onChange={this.changeTypeReport}
                        options={[
                            {label: 'Кассовые статьи', value: 'articlesCash'},
                            {label: 'Расходы вне смены', value: 'otherExpenditure'},
                        ]}
                        placeholder="Тип отчета"
                        noOptionsMessage={() => '...'}
                        />
                    </div>}
                    {(window.innerWidth > 1024 || this.props.UImobile.openFilters) &&
                    <>
                        <div style={{ width: 150 }}>
                            <Select
                            isLoading={this.props.loadingArticles || this.props.loadingFilials}
                            isDisabled={this.props.loadingArticles || this.props.loadingFilials}
                            value={this.state.articlesFilters.article}
                            closeMenuOnSelect={true}
                            onChange={this.setArticleFilters('article')}
                            options={this.optionsArticles()}
                            placeholder="Статья"
                            noOptionsMessage={() => 'Нет статей'}
                            />
                        </div>
                        <div style={{ width: 150 }}>
                            <Select
                            isLoading={this.props.loadingArticles || this.props.loadingFilials}
                            isDisabled={this.props.loadingArticles || this.props.loadingFilials}
                            value={this.state.articlesFilters.typeTransaction}
                            closeMenuOnSelect={true}
                            onChange={this.setArticleFilters('typeTransaction')}
                            options={[
                                {value: null, label: 'Оба типа'},
                                {value: 'cash', label: 'Наличные'},
                                {value: 'noncash', label: 'Безнал. '}
                            ]}
                            placeholder="Тип транзакции"
                            noOptionsMessage={() => 'Нет типов'}
                            />
                        </div>
                        {this.state.typeReport.value === 'articlesCash' && 
                            <div style={{ width: 150 }}>
                                <Select
                                isLoading={this.props.loadingArticles || this.props.loadingFilials}
                                isDisabled={this.props.loadingArticles || this.props.loadingFilials}
                                value={this.state.articlesFilters.typeMovementCash}
                                closeMenuOnSelect={true}
                                onChange={this.setArticleFilters('typeMovementCash')}
                                options={optionsMovementCash}
                                placeholder="Тип *"
                                noOptionsMessage={() => 'Нет типов'}
                                />
                            </div>
                        }
                        <div className='dateBlock'>
                            <DateInput
                                placeholderText="Дата c"
                                selected={this.props.filters.createdStartDate}
                                onChange={this.onChangeDateInput('createdStartDate')}
                                required={this.props.filters.createdEndDate}
                            />
                            <div>-</div>
                            <DateInput
                                placeholderText="Дата по"
                                selected={this.props.filters.createdEndDate}
                                onChange={this.onChangeDateInput('createdEndDate')}
                                required={this.props.filters.createdStartDate}
                                maxDate={
                                    this.props.filters.createdStartDate ? moment(this.props.filters.createdStartDate).add(31, 'days').toDate() : null
                                }
                            />
                            {
                                this.props.filters.createdStartDate && this.props.filters.createdEndDate &&
                                <div>
                                    <button
                                        disabled={this.state.typeReport.value === 'articlesCash' && (!this.state.articlesFilters.typeMovementCash || !this.state.articlesFilters.typeMovementCash.value)}
                                        className={`btn ${(this.props.list && this.props.list.length > 0) ? 'btn-danger' : 'btn-success'} btn-icon`}
                                        style={{ height: '2.5rem', width: '2.5rem' }}
                                        onClick={this.onSearchDate}
                                    >
                                        <i className={(this.props.list && this.props.list.length > 0) ? 'flaticon2-cross' : 'flaticon2-check-mark'}/>
                                    </button>
                                </div>
                            }
                        </div>
                    </>
                    }
            </div>
            ); 
    }

    render() {
        if (this.props.loading) {
            return (
                <div style={styles.loading}><Loader /></div>
            );
        }  
        
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div className="kt-portlet__body">
                        <div className="kt-form kt-form--label-right kt-margin-b-10">
                            {this.renderFiltersBlock()}
                        </div>
                    </div>
                <Portlet fit={true}>
                    <ErrorContainer field="workingShift" style={{ margin: 15 }} hasCloseButton={true}/>
                    <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
                        {this.state.typeReport.value === 'articlesCash' && <ReportWorkingShiftsTable items={this.props.articlesCash} filters={this.state.articlesFilters} workingShifts={this.props.workingShiftsList}/>}
                        {this.state.typeReport.value === 'otherExpenditure' && <ReportOtherExpenditureTable items={this.props.articlesExpenditures} filters={this.state.articlesFilters} otherExpenditures={this.props.otherExpenditures}/>}
                    </div>
                </Portlet>
            </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    filters: state.cassa.filters,
    loading: state.loaders.otherExpenditures || state.loaders.workingShift,
    otherExpenditures: state.cassa.otherExpenditures,
    workingShiftsList: state.cassa.list,
    articlesExpenditures: state.handbook.articlesExpenditures,
    articlesCash: state.handbook.articlesCash,
    role: state.user.info.role.id,
    loadingArticles: state.loaders.articleExpenditures || state.loaders.articlesCash,
    loadingFilials: state.loaders.filials,
    filials: state.handbook.filials,
    UImobile: state.UImobile,
});

const mapDispatchToProps = {
    fetchFilials: (city) => fetchFilials(city, true),
    fetchArticlesExpenditures: (isGetAll) => fetchArticlesExpenditures(isGetAll),
    fetchArticlesCash: (isGetAll) => fetchArticlesCash(isGetAll),
    fetchOtherExpenditures: () => fetchOtherExpenditures(),
    setOtherExpenditures: (data) => setOtherExpenditures(data),
    fetchWorkingShift: () => fetchWorkingShift(),
    setWorkingShifts: (data) => setWorkingShifts(data),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton),
    setCassaFilters: (filters) => setCassaFilters(filters),
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportList);